import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            主题索引
          </h2>
          <p className="text-sm text-foreground-500">按分类快速找到你想看的黑料内容，精准定位感兴趣的话题</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-3 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-accent-300/60 hover:bg-accent-50/30 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.name}
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.count} 条内容</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}